const overrideTableStyles = theme => ({
	MuiTableCell: {
		styleOverrides: {
			head: {
				color: theme.palette.common.white,
				fontWeight: 'bold',
			}
		}
	},
	MuiTableHeadRow: {
		styleOverrides: {
			root: {
				backgroundColor: theme.palette.primary.main,
			}
		}
	},
	MuiButtonBase: {
		styleOverrides: {
			root: {
				'& .MuiMenuItem-root': {
					color: theme.palette.common.white,
				}
			},
		},
	},
	MuiTableSortLabel: {
		styleOverrides: {
			root: {
				'&.Mui-active': {
					'& .MuiTableSortLabel-icon': {
						color: theme.palette.common.white,
					},
				},
			},
		},
	},
	MUIDataTableSelectCell: {
		styleOverrides: {
			headerCell: {
				backgroundColor: theme.palette.primary.main,
				'& div': {
					'& span': {
						color: theme.palette.primary.light,
					},
					'& span.Mui-checked': {
						color: theme.palette.primary.light,
					},
				},
			},
			checkboxRoot: {
				color: theme.palette.primary.main
			}
		}
	},
	MUIDataTable: {
		styleOverrides: {
			paper: {
				padding: theme.spacing(2),
			},
			responsiveBase: {
				borderTopLeftRadius: 6,
				borderTopRightRadius: 6,
			}
		}
	},
	MUIDataTableHeadCell: {
		styleOverrides: {
			root: {
				backgroundColor: theme.palette.primary.main,
				paddingTop: 4,
				paddingBottom: 4
			},
			sortActive: {
				color: theme.palette.common.white,
			},
			toolButton: {
				margin: '0px !important',
			}
		}
	},
	MuiToolbar: {
		styleOverrides: {
			root: {
				alignItems: 'flex-start',
				paddingRight: '24px !important',
				paddingLeft: '4px !important',
				marginBottom: 4,
				minHeight: 40,
				'&.app-toolbar': {
					alignItems: "center",
					marginRight: 8,
					gap: 1,
					'& h6': {
						overflow: "visible !important"
					}
				}
			}
		}
	},
	MuiTablePagination: {
		styleOverrides: {
			toolbar: {
				alignItems: "center",
				flexWrap: 'wrap',
				justifyContent: 'flex-end',
			},
			actions: {
				marginRight: 0,
			}
		}
	},
	MUIDataTableFilterList: {
		styleOverrides: {
			chip: {
				margin: 8
			}
		}
	},
	MUIDataTableToolbar: {
		styleOverrides: {
			actions: {
				'& .MUIDataTableToolbar-customActions': {
					border: 0,
					paddingTop: 0
				},
			}
		}
	},
	MUIDataTableToolbarSelect: {
		styleOverrides: {
			root: {
				marginBottom: 16
			}
		}
	}
})

export default overrideTableStyles